import { VaultSecretsService } from '../services/vault-auth';
import type { VaultSecretRequest } from '../services/vault-auth';

type VaultSecretPayload = VaultSecretRequest;

export const generateVaultSecret = (payload: VaultSecretPayload) => {
  return VaultSecretsService.addSecretToVaultVaultV1VaultAddSecretPost(payload);
};
